import LTooltip from './LTooltip.vue'

export default (Vue) => {
  Vue.component(LTooltip.name, LTooltip)
}
